import { render, staticRenderFns } from "./ClientesEvolucaoQuantidadeCliente.vue?vue&type=template&id=445fe2a2&scoped=true&"
import script from "./ClientesEvolucaoQuantidadeCliente.vue?vue&type=script&lang=js&"
export * from "./ClientesEvolucaoQuantidadeCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClientesEvolucaoQuantidadeCliente.vue?vue&type=style&index=0&id=445fe2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445fe2a2",
  null
  
)

export default component.exports